import { addEdge, applyEdgeChanges, applyNodeChanges } from '@xyflow/react'
import { addLinkedEntityData, setSidebarValue, updateConfig, updateEdge, updateNode } from './utils'

export function EntityGraphReducer (state, action) {
  switch (action.type) {
    case 'UPDATE_CONFIG': {
      const { path, value } = action.payload
      return updateConfig(state, path, value)
    }
    case 'UPDATE_NODES': {
      const updatedNodes = applyNodeChanges(action.payload, state.data.nodes)
      return {
        ...state,
        stateHasChanged: true,
        data: {
          ...state.data,
          nodes: updatedNodes
        }
      }
    }
    case 'UPDATE_EDGES': {
      const updatedEdges = applyEdgeChanges(action.payload, state.data.edges)
      return {
        ...state,
        stateHasChanged: true,
        data: {
          ...state.data,
          edges: updatedEdges
        }
      }
    }

    case 'ADD_NODE': {
      const newNode = action.payload
      return {
        ...state,
        stateHasChanged: true,
        data: {
          ...state.data,
          nodes: [...state.data.nodes, newNode]
        }
      }
    }

    case 'ADD_EDGE': {
      const newEdges = addEdge(action.payload, state.data.edges)
      return {
        ...state,
        stateHasChanged: true,
        data: {
          ...state.data,
          edges: newEdges
        }
      }
    }

    case 'TOGGLE_EDIT_SIDEBAR': {
      const { path, value } = action.payload
      return setSidebarValue(state, path, value)
    }

    case 'UPDATE_NODE': {
      const { nodeId, path, value } = action.payload
      return updateNode(state, nodeId, path, value)
    }

    case 'UPDATE_EDGE': {
      const { edgeId, path, value } = action.payload
      return updateEdge(state, edgeId, path, value)
    }

    case 'ADD_LINKED_ENTITY_DATA': {
      const { levelTypeId, levelId, value } = action.payload
      return addLinkedEntityData(state, levelTypeId, levelId, value)
    }

    default: {
      return state
    }
  }
}
